import type { IAddressComponents } from 'models/location'

export const parseAddressComponents = (
	addressComponents: google.maps.GeocoderAddressComponent[] | null | undefined
): IAddressComponents => {
	if (
		addressComponents !== null &&
		addressComponents !== undefined &&
		addressComponents.length > 0
	) {
		// eslint-disable-next-line unicorn/no-array-reduce
		return addressComponents.reduce((p: IAddressComponents, c) => {
			const updatedAddress: IAddressComponents = { ...p }
			if (c.types.length > 0) {
				switch (c.types[0]) {
					case 'street_number': {
						updatedAddress.streetNumber = c.long_name
						break
					}
					case 'route': {
						updatedAddress.route = c.long_name
						break
					}
					case 'locality':
					case 'postal_town': {
						updatedAddress.city = c.long_name
						break
					}
					case 'administrative_area_level_1': {
						updatedAddress.state = c.short_name
						break
					}
					case 'postal_code': {
						updatedAddress.zip = c.long_name
						break
					}
					case 'country': {
						updatedAddress.country = c.short_name
						break
					}
					default: {
						// noop
						break
					}
				}
				if (c.types.includes('sublocality')) {
					updatedAddress.route = `${updatedAddress.route} ${c.long_name}`
				}
			}
			return updatedAddress
		}, {})
	}
	return {}
}

export const locationTypes = {
	ROOFTOP: 'ROOFTOP',
	RANGE_INTERPOLATED: 'RANGE_INTERPOLATED',
	GEOMETRIC_CENTER: 'GEOMETRIC_CENTER',
	APPROXIMATE: 'APPROXIMATE'
}

export const geocodeByAddress = (
	address: string
): Promise<google.maps.GeocoderResult[] | null> => {
	const geocoder = new window.google.maps.Geocoder()
	const OK = window.google.maps.GeocoderStatus.OK

	return new Promise((resolve, reject) => {
		geocoder.geocode({ address }, (results, status) => {
			if (status !== OK) {
				reject(status)
			}
			resolve(results)
		})
	})
}
